<bzg-modal-header>
  <span class="bzg-modal__header">{{ data.title }}</span>
  <bzg-button-icon class="" icon="icon-close" (click)="close()"></bzg-button-icon>
</bzg-modal-header>
<bzg-modal-content>
  <span [innerHTML]="data.message"></span>

  <div class="bz-space--stack-m">
    <bzg-input
      [(ngModel)]="password"
      [type]="passwordInputType"
      [placeholder]="data.passwordPlaceholder || ('GLOBAL.PASSWORD' | translate)"
      actionIcnPosition="right"
      [autocomplete]="'new-password'">
      {{ 'GLOBAL.PASSWORD' | translate }}
      <bzg-icon nameIcon="icon-eye" *ngIf="showPassword" (click)="togglePasswordVisibility()" class="download-certificate-password-modal__pointer"></bzg-icon>
      <bzg-icon nameIcon="icon-eye-closed" *ngIf="!showPassword" (click)="togglePasswordVisibility()" class="download-certificate-password-modal__pointer"></bzg-icon>
    </bzg-input>
  </div>
</bzg-modal-content>
<bzg-modal-footer [ngClass]="{'color-cancel-button': isActionDisabled}">
  <bzg-button-secondary (click)="close()" class="bz-space--inline-m">{{ data.cancelButton || ('GLOBAL.CANCEL' | translate) }}
  </bzg-button-secondary>
  <bzg-button-primary (click)="confirm()">
    {{ data.button }}
  </bzg-button-primary>
</bzg-modal-footer>
